export enum FileType {
  IMAGE = 'image',
  VIDEO = 'video',
  FILE = 'file',
}
